// @flow
import { RESORT_FLASH_INFO } from 'Client/cms/toolkit/constants';
import { ProductFlashInfoLine } from 'Components/lines/product-flash-info-line/ProductFlashInfoLine';
import { productFlashInfoResolver } from './productFlashInfo.resolver';

export const productFlashInfoDescriptor = {
  name: RESORT_FLASH_INFO,
  component: ProductFlashInfoLine,
  resolve: productFlashInfoResolver.resolve,
};
